import { useTranslation } from 'react-i18next';
import { getAsLongDateTime, getAsLongDate } from '../../services/ukgDateTime';
import './BidPeriods.scss';

/**
 * @param {{
    * requestPeriodStartDate: Date;
    * requestPeriodEndDate: Date;
    * submissionPeriodStartDate: Date;
    * submissionPeriodEndDate: Date;
    * priorityStart?: Date;
    * priorityEnd?: Date;
    * isForeverRequestPeriod?: boolean;
    * foreverLabel?: string;
    * }} param0
 */
const BidPeriods = ({
    requestPeriodStartDate,
    requestPeriodEndDate,
    submissionPeriodStartDate,
    submissionPeriodEndDate,
    priorityStart,
    priorityEnd,
    isForeverRequestPeriod = false,
    foreverLabel = 'Anytime',

}) => {
    const { t } = useTranslation('bid', { keyPrefix: 'periods' });
    const requestEndLabel = isForeverRequestPeriod ? foreverLabel : getAsLongDate(requestPeriodEndDate);

    return (
        <div className="bid-periods-info-tooltip">
            {priorityStart && priorityEnd && (
                <>
                    <div className="bid-periods-info-row">
                        <label>{`${t('priorityStart')}: `}</label>
                        <span>{getAsLongDateTime(priorityStart)}</span>
                    </div>
                    <div className="bid-periods-info-row">
                        <label>{`${t('priorityEnd')}: `}</label>
                        <span>{getAsLongDateTime(priorityEnd)}</span>
                    </div>
                </>
            )}
            <div className="bid-periods-info-row">
                <label>{`${t('submissionStart')}: `}</label>
                <span>{getAsLongDateTime(submissionPeriodStartDate)}</span>
            </div>
            <div className="bid-periods-info-row">
                <label>{`${t('submissionEnd')}: `}</label>
                <span>{getAsLongDateTime(submissionPeriodEndDate)}</span>
            </div>
            <div className="bid-periods-info-row">
                <label>{`${t('request')}: `}</label>
                <span>{`${getAsLongDate(requestPeriodStartDate)} ${t('seperator.to')} ${requestEndLabel}`}</span>
            </div>
        </div>
    );
};

export default BidPeriods;
